<ion-radio-group class="background-colored" [value]="activePaymentMethod">
  <div
    *ngIf="product?.type === productType.EVENT_TICKET"
    class="flex-space-between margin-sides-small padding-vert-small border-top"
    (click)="setPaymentMethod(paymentMethod.PAYPAL)"
  >
    <div class="flex-space-between">
      <img class="item-small" src="/assets/imgs/payments/paypal.png" />
      <p class="font-black margin-left-small">{{ 'PAY_WITH_PAYPAL' | translate }}</p>
    </div>
  </div>

  <div
    class="flex-space-between margin-sides-small padding-vert-small border-both"
    (click)="setPaymentMethod(paymentMethod.CREDIT_CARD)"
  >
    <div class="flex-space-between">
      <img class="item-medium" src="/assets/imgs/payments/creditcard.jpg" />
      <p class="font-black margin-left-small">{{ 'PAY_WITH_CREDITCARD' | translate }}</p>
    </div>
  </div>

  <ion-card *ngIf="activePaymentMethod === paymentMethod.CREDIT_CARD" class="welcome-card">
    <ion-card-content>
      <div class="form-row" style="padding-left: 1px;">
        <div id="card-element"></div>
        <div id="card-errors" role="alert"></div>
      </div>
      <ion-button
        expand="block"
        size="small"
        style="margin-top: 1rem"
        (click)="payCreditCard()"
      >
        {{ 'PAY_NOW' | translate }}
      </ion-button>
    </ion-card-content>
  </ion-card>

  <div
    *ngIf="product?.currency?.toLowerCase() === 'eur'"
    class="flex-space-between margin-sides-small padding-vert-small border-both"
    (click)="payGiropay()"
  >
    <div class="flex-space-between">
      <img class="item-giropay" src="/assets/imgs/payments/gyropay.png" />
      <p class="font-black margin-left-small">{{ 'PAY_WITH_GIROPAY' | translate }}</p>
    </div>
  </div>

  <div
    *ngIf="product?.currency?.toLowerCase() === 'eur'"
    class="flex-space-between margin-sides-small padding-vert-small border-both"
    (click)="paySofort()"
  >
    <div class="flex-space-between">
      <img class="item-sofort" src="/assets/imgs/payments/sofort.png" />
      <p class="font-black margin-left-small">{{ 'PAY_WITH_SOFORT' | translate }}</p>
    </div>
  </div>
</ion-radio-group>

<ion-item (click)="redeemCoupon($event)">
  <ion-input
    class="box"
    slot="start"
    [(ngModel)]="couponCode"
    type="text"
    placeholder="{{ 'ENTER_CODE' | translate }}"
  >
  </ion-input>
  <ion-label class="font-small" slot="end">{{ 'REDEEM_COUPON' | translate }}</ion-label>
</ion-item>
